import isNoteSemaphore from 'app/forms/validations/isNoteSemaphore';

export const SEMAPHORE_FEEDBACK_DETAIL_FORM_NAME = 'semaphore-feedback-detail';

export const FIELDS = {
	feedbackNote: 'feedbackNote',
};

export default () => ({
	[FIELDS.feedbackNote]: {
		deepPath: [FIELDS.feedbackNote],
		validations: [isNoteSemaphore()],
	},
});
